import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ADMIN, ADMIN_RECINTO } from '../../helpers/Constants';

const IndexGuard = () => {
  const { isAuthenticated, user } = useSelector(state => state.auth);

  if (isAuthenticated) {
    if (user?.tipo === ADMIN) return <Redirect to="/admin/recintos" />;
    if (user?.tipo === ADMIN_RECINTO) {
      return <Redirect to={`/admin-recinto/recintos/${user?.idRecinto}`} />;
    }
  } else {
    return <Redirect to="/login" />;
  }
};

export default IndexGuard;
